module.exports = __webpack_public_path__ + "static/media/5-mobile.1ed91a84.webp";